import { render } from "./RankBoard_home.vue?vue&type=template&id=24032f9c"
import script from "./RankBoard_home.vue?vue&type=script&lang=js"
export * from "./RankBoard_home.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__